<script lang="ts">
  import { faceSmilingIcon } from '@nrk/core-icons';
</script>

<!-- eslint-disable-next-line svelte/no-at-html-tags -->
{@html faceSmilingIcon}
